
/* ────────────────────────────────────────────────────────────────
AK_DR neue initialisierung in der sliderRegistry
────────────────────────────────────────────────────────────────
use this parameters in the splide slider section:
# data-section-sliderid="your_type_key" (alt -> webpack: data-section-class)

# block (splide__slide):
- data-block-id="{{ block.id }}" 
- data-index="{{ forloop.index0 }}" 
- {{ block.shopify_attributes }}
─────────────────────────────────────────────────────────────────── */

(function () {
  // 'use strict';

  // ── default splide options ────────────────────────────────────────────────────────────────
  const collectionSliderDefault = {
    type: 'slide',
    width: '1040px',
    speed: 650,
    perPage: 4,
    perMove: 4,
    gap: 10,
    pagination: false,
    drag: true,
    snap: true,
    flickPower: 200,
    easing: 'ease',
    breakpoints: {
      1140: {
        perPage: 3,
        perMove: 3,
      },
      770: {
        perPage: 2,
        perMove: 2,
      },
      500: {
        perPage: 1,
        perMove: 1,
      },
    },
  }


 /*
  Nicht die Option „perPage“ für den Navigations-Slider der Timeline benutzen, um die Anzahl festzulegen. 
 */
 /*
  const timelineNavigation = {
    fixedWidth  : 100,
    fixedHeight : 40,
    gap         : 0,
    rewind      : true,
    pagination  : false,
    isNavigation: true,
    padding     : { left: padding+'%', right: padding+'%' },
    breakpoints : {
      750: {
        fixedWidth: 60,
        padding: { left: '2em', right: '2em' },
      },
    },
  }
  */



  // ── functions ────────────────────────────────────────────────────────────────
  function playActiveVideo(splide) {
    const active = splide.index;
    splide.Components.Elements.slides.forEach((slide, i) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (i === active) {
        video.play();
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function overlayToggleIn(splide, index) {
    const slide = splide.Components.Elements.slides[index];
    const content = slide.querySelector('.Slideshow__overlay-content');
    content.classList.add('slide_up');
  }

  function overlayToggleOut(splide, index) {
    const slide = splide.Components.Elements.slides[index];
    const content = slide.querySelector('.Slideshow__overlay-content');
    content.classList.remove('slide_up');
  }

  /**
   * Triggers a brief jitter on the splide root when it first enters the viewport.
   * CSS (.is-flickering) drives the keyframe animation; JS only adds/removes the class.
   * Only fires once per page load (observer disconnects after first trigger).
   */
  function initFlickerAnimation(splide) {
    const root = splide.root;
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        root.classList.add('is-flickering');
        root.addEventListener('animationend', () => root.classList.remove('is-flickering'), { once: true });
        obs.unobserve(root);
      });
    }, { threshold: 0.5 });
    observer.observe(root);
  }

  /**
   * Reads the animation setting from the splide root and applies the matching effects.
   * Supported: class `flicker-animation` / `zoom-animation` or `data-animation="flicker|zoom"`.
   * Add this call to any registry's onMount (or customInit) to enable the animations for that slider type.
   * Styles live in splide-ak.css; zoom scales the direct child of each `.splide__slide`.
   */
  function applySliderAnimations(splide) {
    const { classList, dataset } = splide.root;
    if (classList.contains('flicker-animation') || dataset.animation === 'flicker') initFlickerAnimation(splide);
    // zoom is handled entirely by CSS; no JS hook needed
  }

  /**
   * Registry: one entry per data-section-sliderid value.
   * Each slider type gets its own Splide events and an onMount hook.
   * Options (perPage, autoplay, etc.) come from data-splide in Liquid — keep them there.
   *
   * To add a new slider type:
   *   1. Create a new section .liquid file with data-section-sliderid="your_type_key"
   *   2. Add a matching entry below with the desired events / onMount logic
   */
  const sliderRegistry = {
    ak_collection_slider: {
      defaultOptions: collectionSliderDefault,
      events: {},
      onMount(splide) {}
    },

    ak_hero_slider: {
      events: {},
      onMount(splide) {
        const overlayAnimation = splide.root.attributes['data-animation'].value;

        splide.on('moved', () => playActiveVideo(splide));
        playActiveVideo(splide);

        // if (!overlayAnimation) return;
        if (overlayAnimation == 'overlay_slide_in') {
          splide.on('visible', (Slide) => overlayToggleIn(splide, Slide.index));
          overlayToggleIn(splide, splide.index);
          splide.on('hidden', (Slide) => overlayToggleOut(splide, Slide.index));
        }

        // CHH 2026-09-07: Die query selector lösen nicht mehr auf. Workaround.
        splide.on('visible', (Slide) => {
          const slide = splide.Components.Elements.slides[Slide.index];
          const animationMedia = slide.querySelector('.slideshow-media');
          if (animationMedia?.classList) {
            animationMedia.classList.add('scale');
          }
        })
        splide.on('hidden', (Slide) => {
          const slide = splide.Components.Elements.slides[Slide.index];
          const animationMedia = slide.querySelector('.slideshow-media');
          if (animationMedia?.classList) {
            animationMedia.classList.remove('scale');
          }
        })
      }
    },

    ak_slideshow: {
      events: {},
      onMount(splide) {  
        // const slideAnimation = splide.root.attributes['data-slide-animation'].value;    
        const overlayAnimation = splide.root.attributes['data-overlay-animation'].value;

        splide.on('moved', () => playActiveVideo(splide));
        playActiveVideo(splide);

        if (overlayAnimation == 'slide-in') {
          splide.on('visible', (Slide) => overlayToggleIn(splide, Slide.index));
          overlayToggleIn(splide, splide.index);
          splide.on('hidden', (Slide) => overlayToggleOut(splide, Slide.index));
        }

        // if (!slideAnimation) return;
        splide.on('visible', (Slide) => {
          const slide = splide.Components.Elements.slides[Slide.index];
          const animationMedia = slide.querySelector('.slideshow-media');
          animationMedia.classList.add('scale');
        })
        splide.on('hidden', (Slide) => {
          const slide = splide.Components.Elements.slides[Slide.index];
          const animationMedia = slide.querySelector('.slideshow-media');
          animationMedia.classList.remove('scale');
        })

      }
    },

    item_slider: {
      events: {},
      onMount(splide) {
        applySliderAnimations(splide);
      }
    },

    featured_product: {
      customInit(sectionEl) {
        const wrappers = sectionEl.querySelectorAll('.splide-wrapper');
        const sliderArray = [];
        const instances = [];

        wrappers.forEach((wrapper) => {
          const mainEl = wrapper.querySelector('.ak-splide-product');
          const thumbEl = wrapper.querySelector('.ak-splide-thumbs');
          if (!mainEl) return;

          const main = new Splide(mainEl, {
            type: 'slide',
            rewind: true,
            pagination: false,
            arrows: true,
          });

          if (thumbEl) {
            const thumbs = new Splide(thumbEl, {
              fixedWidth: 80,
              fixedHeight: 80,
              gap: 5,
              rewind: true,
              pagination: false,
              arrows: true,
              isNavigation: true,
            });
            main.sync(thumbs);
            main.mount();
            thumbs.mount();
            instances.push(main, thumbs);
          } else {
            main.mount();
            instances.push(main);
          }

          applySliderAnimations(main);
          sliderArray.push(main);
        });

        sectionEl._splide = sliderArray[0];
        sectionEl._splides = instances;
        window.sliderArray = sliderArray;
      }
    },

    ak_timeline: {
      customInit(sectionEl) {
        const wrappers = sectionEl.querySelectorAll('.splide-wrapper');
        const sliderArray = [];
        const instances = [];

        // const splides = splide.Components.Elements.slides.length;
        const splides = sectionEl.querySelectorAll('.splide__slide').length;
        const padding = (splides < 5) ? 100 / splides : 10;

        wrappers.forEach((wrapper) => {
          const mainEl = wrapper.querySelector('.splide-main');
          const navEl = wrapper.querySelector('.splide-nav');
          if (!mainEl) return;

          const main = new Splide(mainEl, {
            type: 'slide',
            rewind: true,
            pagination: false,
            arrows: true,
          });

          if (navEl) {
            const nav = new Splide(navEl, {
              fixedWidth  : 100,
              fixedHeight : 40,
              gap         : 0,
              rewind      : true,
              pagination  : false,
              isNavigation: true,
              padding     : { left: padding+'%', right: padding+'%' },
              breakpoints : {
                  750: {
                      fixedWidth: 60,
                      padding: { left: '2em', right: '2em' },
                  },
              },
          });
  
            // const nav = new Splide(navEl, timelineNavigation);
            main.sync(nav);
            main.mount();
            nav.mount();
            instances.push(main, nav);
          } else {
            main.mount();
            instances.push(main);
          }

          sliderArray.push(main);
        });

        sectionEl._splide = sliderArray[0];
        sectionEl._splides = instances;
        window.sliderArray = sliderArray;
      }
    },

    /* ── Example: hero fullscreen slider ──────────────────────────────────
    ak_hero_slider: {
      events: {
        moved(splide, newIndex) {
          const counter = document.querySelector('.hero__slide-count');
          if (counter) counter.textContent = `${newIndex + 1} / ${splide.length}`;
        }
      },
      onMount(splide) {
        // pause autoplay while a video slide is active
        splide.Components.Elements.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (!video) return;
          video.addEventListener('play', () => splide.Components.Autoplay.pause());
          video.addEventListener('ended', () => splide.Components.Autoplay.play());
        });
      }
    },
    ──────────────────────────────────────────────────────────────────────── */

    /* ── Example: product thumbnail slider with sync ──────────────────────
    ak_product_slider: {
      events: {},
      onMount(splide) {
        const thumbEl = document.querySelector(`[data-thumb-for="${splide.root.id}"]`);
        if (!thumbEl) return;
        const thumbs = new Splide(thumbEl, { fixedWidth: 80, gap: 8, rewind: true, pagination: false, isNavigation: true });
        splide.sync(thumbs);
        thumbs.mount();
      }
    }
    ──────────────────────────────────────────────────────────────────────── */
  };

  // ── Core ────────────────────────────────────────────────────────────────
  function createSlider(sectionEl) {
    const type = sectionEl.dataset.sectionSliderid;
    if (sectionEl._splide) return;

    const config = sliderRegistry[type] || {};

    /* 
    Falls ein Slider einen "thumb-Slider" zur navigation besitzt: 
    Paar-Logik (main + thumbs synced) passt nicht in das Standard-forEach-Muster von createSlider
    -> deshalb wird ein customInit-Hook ins Registry-System eingefügt */
    if (config.customInit) {
      config.customInit(sectionEl);
      return;
    }

    const splideEls = sectionEl.querySelectorAll('.splide');
    if (!splideEls.length) return;

    const instances = [];

    splideEls.forEach(splideEl => {
      const splide = new Splide(splideEl, config.defaultOptions || {}); // data-splide überschreibt bei Bedarf defaultOptions

      if (config.events) {
        Object.entries(config.events).forEach(([event, handler]) => {
          splide.on(event, function () { handler(splide, ...arguments); });
        });
      }

      splide.mount();
      if (config.onMount) config.onMount(splide);
      instances.push(splide);
    });

    sectionEl._splide = instances[0];
    if (instances.length > 1) sectionEl._splides = instances;
  }

  function destroySlider(sectionEl) {
    if (sectionEl._splides) {
      sectionEl._splides.forEach(s => s.destroy());
      delete sectionEl._splides;
    } else if (sectionEl._splide) {
      sectionEl._splide.destroy();
    }
    delete sectionEl._splide;
  }

  function initAll() {
    document.querySelectorAll('[data-section-sliderid]').forEach(createSlider);
  }





  // ── Shopify theme editor lifecycle ──────────────────────────────────────
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', ({ target }) => {
      const el = target.querySelector('[data-section-sliderid]');
      if (el) createSlider(el);
    });

    document.addEventListener('shopify:section:unload', ({ target }) => {
      const el = target.querySelector('[data-section-sliderid]');
      if (el) destroySlider(el);
    });



    /* LÖSUNG 1
      sucht über detail.sectionId nach dem Section-Element 
      kann Probleme geben, weil section.id nicht zwingend mit Event-sectionId übereinstimmt
    */
    /*
      document.addEventListener('shopify:block:select', ({ detail }) => {
        const sectionEl = document.querySelector(`[data-section-id="${detail.sectionId}"][data-section-sliderid]`);
        if (!sectionEl?._splide) return;

        const splide = sectionEl._splide;
        const slides = splide.Components.Elements.slides;
        const index = slides.findIndex((slide) => slide.dataset.blockId === detail.blockId);

        if (index !== -1) splide.go(index);

        const autoplay = splide.Components.Autoplay;
        if (autoplay) autoplay.pause();
      });

      document.addEventListener('shopify:block:deselect', ({ detail }) => {
        const sectionEl = document.querySelector(`[data-section-id="${detail.sectionId}"][data-section-sliderid]`);
        if (!sectionEl?._splide) return;

        const splide = sectionEl._splide;
        const autoplay = splide.Components.Autoplay;
        if (autoplay && splide.options.autoplay) autoplay.play();
      });
    */


    /*   LÖSUNG 2
      - detail.blockId → findet den Slide direkt über data-block-id (kein sectionId-Matching) 
      - slideEl.closest('[data-section-sliderid]') → navigiert zur Parent-Section
      - slideEl.dataset.index → liest den vorberechneten 0-basierten Index aus dem Liquid-Attribut — funktioniert auch bei Splide-Clones (Loop-Modus)
    */
    document.addEventListener('shopify:block:select', ({ detail }) => {
      const slideEl = document.querySelector(`[data-block-id="${detail.blockId}"]`);
      if (!slideEl) return;

      const sectionEl = slideEl.closest('[data-section-sliderid]');
      if (!sectionEl?._splide) return;

      const index = parseInt(slideEl.dataset.index, 10);
      if (!isNaN(index)) sectionEl._splide.go(index);

      const autoplay = sectionEl._splide.Components.Autoplay;
      if (autoplay) autoplay.pause();
    });

    document.addEventListener('shopify:block:deselect', ({ detail }) => {
      const slideEl = document.querySelector(`[data-block-id="${detail.blockId}"]`);
      if (!slideEl) return;

      const sectionEl = slideEl.closest('[data-section-sliderid]');
      if (!sectionEl?._splide) return;

      const splide = sectionEl._splide;
      const autoplay = splide.Components.Autoplay;
      if (autoplay && splide.options.autoplay) autoplay.play();
    });
  }


  // ── Boot ────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();


// trustpilot splide slider [Rayan]
// ist jetzt ein ak_collection_slider
/*
let splideInstances = {}

function updateSplideOptionsById(id, newOptions) {
  let splide = splideInstances[id]
  if (splide) {
    splide.destroy()
    splideInstances[id] = new Splide('#' + id, newOptions).mount()
  } else {
    console.warn('Splide instance with ID ' + id + ' not found.')
  }
}

document.addEventListener('DOMContentLoaded', function () {
  var tpSplideElement = document.getElementById('tpSplide');
  if (tpSplideElement) {
    var slideCount = tpSplideElement.querySelectorAll('.splide__slide').length;

    var tpSplideOptions = {
      type: 'slide',
      width: '700px',
      speed: 650,
      perPage: slideCount === 1 ? 1 : 2,
      perMove: slideCount === 1 ? 1 : 2,
      pagination: false,
      drag: slideCount > 1,
      snap: true,
      flickPower: 200,
      gap: 12,
      easing: 'ease',
      arrows: slideCount > 1,
      breakpoints: {
        1140: {
          perPage: slideCount === 1 ? 1 : 3,
          perMove: slideCount === 1 ? 1 : 3,
        },
        770: {
          perPage: 1,
          perMove: 1,
          width: '100%',
          height: 'auto',
        },
      },
    };
    updateSplideOptionsById('tpSplide', tpSplideOptions);
  }
})
*/